import { render, staticRenderFns } from "./Moq.vue?vue&type=template&id=b8ac5256&"
import script from "./Moq.vue?vue&type=script&lang=js&"
export * from "./Moq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports